const BACK_API = process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : '';
const config = {
  NODE_ENV: process.env.NODE_ENV,
  BACK_API
};

export default config;
